import gettingStarted from "./content/getting-started.md?raw";
import childrenFamilies from "./content/children-families.md?raw";
import billingPayments from "./content/billing-payments.md?raw";
import messaging from "./content/messaging.md?raw";
import attendance from "./content/attendance.md?raw";
import faq from "./content/faq.md?raw";

export interface GuideEntry {
  slug: string;
  title: string;
  category: "getting-started" | "features" | "faq";
  content: string;
}

export const guideEntries: GuideEntry[] = [
  {
    slug: "getting-started",
    title: "Getting Started",
    category: "getting-started",
    content: gettingStarted,
  },
  {
    slug: "children-families",
    title: "Children & Families",
    category: "features",
    content: childrenFamilies,
  },
  {
    slug: "billing-payments",
    title: "Billing & Payments",
    category: "features",
    content: billingPayments,
  },
  {
    slug: "messaging",
    title: "Messaging",
    category: "features",
    content: messaging,
  },
  {
    slug: "attendance",
    title: "Attendance & Check-In",
    category: "features",
    content: attendance,
  },
  {
    slug: "faq",
    title: "FAQ & Troubleshooting",
    category: "faq",
    content: faq,
  },
];

export const guideCategories = [
  { key: "getting-started" as const, label: "Getting Started" },
  { key: "features" as const, label: "Features" },
  { key: "faq" as const, label: "FAQ" },
];
